module.exports = __webpack_public_path__ + "static/media/Gugi-Regular.deba6882.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/footer/Gugi-Regular.ttf
// module id = 180
// module chunks = 0